import { observer } from "mobx-react-lite";
import * as React from "react";
import { useAuthStore } from "../hooks/useAuthStore";
import AuthStore from "../store/AuthStore";
import SelectLanguage from "../components/SelectLanguage";
import Login from "./Login";
import { MainIsAuthCenter, MainIsAuthToolbar } from "./MainIsAuthComponents";
import ReportView from "./ReportView";
import { isMobileDevice } from "../utils/DeviceDetect";
import VersionInfo from "./VersionInfo";

const MainApp = () => {
    const authStore: AuthStore = useAuthStore();
//    const reportId = "ae2bd5e8-197f-47e1-0ce6-08dad2681345";
    const reportId = new URLSearchParams((location.search ? location.search : "").toLowerCase()).get("reportId".toLowerCase());
    const autoBuildReport = new URLSearchParams((location.search ? location.search : "").toLowerCase()).get("autoBuildReport".toLowerCase()) == "true";
    const exportFormat = new URLSearchParams((location.search ? location.search : "").toLowerCase()).get("exportFormat".toLowerCase()) || "";
    const isDashBoard = new URLSearchParams((location.search ? location.search : "").toLowerCase()).get("isDashBoard".toLowerCase()) == "true";
    const exportFileName = new URLSearchParams((location.search ? location.search : "").toLowerCase()).get("exportFileName".toLowerCase()) || "";
   
    return (
        <div className="main-container">
            <header className="header-container">
                {authStore.isAuth && !reportId && <MainIsAuthToolbar />
                }
                <SelectLanguage visible={false} width="100px" />
            </header>
            <div className="center-container">
                {!authStore.isAuth && <Login />}
                {authStore.isAuth && !reportId && <MainIsAuthCenter />}
                {authStore.isAuth && reportId &&
                    <ReportView
                    reportId={reportId}
                    autoBuildReport={autoBuildReport}
                    exportFormat={exportFormat}
                    isDashBoard={isDashBoard}
                    exportFileName={exportFileName}
                    />
                }
            </div>
            {!isMobileDevice && 
                !isDashBoard &&
                <footer className="footer-container">
                    <span>
                        Copyright © 2022 <a href="http://www.game-keeper.com" target="_blank">www.game-keeper.com</a>. All rights reserved.
                    </span>
                    <VersionInfo/>
                </footer>
            }
        </div>
    )
}
export default observer(MainApp);
